/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";
import MetaTags from "react-meta-tags";
import { Container } from "reactstrap";

const titleColor = {
  width: "100%",
  height: "72px",
  backgroundColor: "#F8F8FA",
  padding: "24px 72px",
};

function Color() {
  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>Color</title>
        </MetaTags>
        <Container fluid>
          <div className="row">
            <div className="col-md-12">
              <h2 className="bold-text">Color Palletes</h2>
            </div>
            <div className="col-md-12 mt-3">
              <div style={titleColor}>
                <span className="body-text--lg bold-text">Red</span>
              </div>
              <div className="row">
                <div className="d-flex justify-content-center">
                  <div
                    style={{ width: 568, height: 56 }}
                    className="d-flex justify-content-between bg-palette-red-100"
                  >
                    <span className="color-white">100</span>
                  </div>
                  <div
                    style={{ width: 568, height: 56 }}
                    className="d-flex justify-content-between bg-palette-red-50"
                  >
                    <span>50</span>
                  </div>
                </div>
              </div>
              <div className="row mt-2">
                <div className="d-flex justify-content-center">
                  <div
                    style={{ width: 568, height: 56 }}
                    className="d-flex justify-content-between bg-palette-red-90"
                  >
                    <span className="color-white">90</span>
                  </div>
                  <div
                    style={{ width: 568, height: 56 }}
                    className="d-flex justify-content-between bg-palette-red-40"
                  >
                    <span>40</span>
                  </div>
                </div>
              </div>
              <div className="row mt-2">
                <div className="d-flex justify-content-center">
                  <div
                    style={{ width: 568, height: 56 }}
                    className="d-flex justify-content-between bg-palette-red-80"
                  >
                    <span className="color-white">80</span>
                  </div>
                  <div
                    style={{ width: 568, height: 56 }}
                    className="d-flex justify-content-between bg-palette-red-30"
                  >
                    <span>30</span>
                  </div>
                </div>
              </div>
              <div className="row mt-2">
                <div className="d-flex justify-content-center">
                  <div
                    style={{ width: 568, height: 56 }}
                    className="d-flex justify-content-between bg-palette-red-70"
                  >
                    <span className="color-white">70</span>
                  </div>
                  <div
                    style={{ width: 568, height: 56 }}
                    className="d-flex justify-content-between bg-palette-red-20"
                  >
                    <span>20</span>
                  </div>
                </div>
              </div>
              <div className="row mt-2">
                <div className="d-flex justify-content-center">
                  <div
                    style={{ width: 568, height: 56 }}
                    className="d-flex justify-content-between bg-palette-red-60"
                  >
                    <span className="color-white">60</span>
                  </div>
                  <div
                    style={{ width: 568, height: 56 }}
                    className="d-flex justify-content-between bg-palette-red-10"
                  >
                    <span>10</span>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-md-12 mt-3">
              <div style={titleColor}>
                <span className="body-text--lg bold-text">RedHover</span>
              </div>
              <div className="row">
                <div className="d-flex justify-content-center">
                  <div
                    style={{ width: 568, height: 56 }}
                    className="d-flex justify-content-between bg-palette-redHover-100"
                  >
                    <span className="color-white">100</span>
                  </div>
                  <div
                    style={{ width: 568, height: 56 }}
                    className="d-flex justify-content-between bg-palette-redHover-50"
                  >
                    <span>50</span>
                  </div>
                </div>
              </div>
              <div className="row mt-2">
                <div className="d-flex justify-content-center">
                  <div
                    style={{ width: 568, height: 56 }}
                    className="d-flex justify-content-between bg-palette-redHover-90"
                  >
                    <span className="color-white">90</span>
                  </div>
                  <div
                    style={{ width: 568, height: 56 }}
                    className="d-flex justify-content-between bg-palette-redHover-40"
                  >
                    <span>40</span>
                  </div>
                </div>
              </div>
              <div className="row mt-2">
                <div className="d-flex justify-content-center">
                  <div
                    style={{ width: 568, height: 56 }}
                    className="d-flex justify-content-between bg-palette-redHover-80"
                  >
                    <span className="color-white">80</span>
                  </div>
                  <div
                    style={{ width: 568, height: 56 }}
                    className="d-flex justify-content-between bg-palette-redHover-30"
                  >
                    <span>30</span>
                  </div>
                </div>
              </div>
              <div className="row mt-2">
                <div className="d-flex justify-content-center">
                  <div
                    style={{ width: 568, height: 56 }}
                    className="d-flex justify-content-between bg-palette-redHover-70"
                  >
                    <span className="color-white">70</span>
                  </div>
                  <div
                    style={{ width: 568, height: 56 }}
                    className="d-flex justify-content-between bg-palette-redHover-20"
                  >
                    <span>20</span>
                  </div>
                </div>
              </div>
              <div className="row mt-2">
                <div className="d-flex justify-content-center">
                  <div
                    style={{ width: 568, height: 56 }}
                    className="d-flex justify-content-between bg-palette-redHover-60"
                  >
                    <span className="color-white">60</span>
                  </div>
                  <div
                    style={{ width: 568, height: 56 }}
                    className="d-flex justify-content-between bg-palette-redHover-10"
                  >
                    <span>10</span>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-md-12 mt-3">
              <div style={titleColor}>
                <span className="body-text--lg bold-text">Magenta</span>
              </div>
              <div className="row">
                <div className="d-flex justify-content-center">
                  <div
                    style={{ width: 568, height: 56 }}
                    className="d-flex justify-content-between bg-palette-magenta-100"
                  >
                    <span className="color-white">100</span>
                  </div>
                  <div
                    style={{ width: 568, height: 56 }}
                    className="d-flex justify-content-between bg-palette-magenta-50"
                  >
                    <span>50</span>
                  </div>
                </div>
              </div>
              <div className="row mt-2">
                <div className="d-flex justify-content-center">
                  <div
                    style={{ width: 568, height: 56 }}
                    className="d-flex justify-content-between bg-palette-magenta-90"
                  >
                    <span className="color-white">90</span>
                  </div>
                  <div
                    style={{ width: 568, height: 56 }}
                    className="d-flex justify-content-between bg-palette-magenta-40"
                  >
                    <span>40</span>
                  </div>
                </div>
              </div>
              <div className="row mt-2">
                <div className="d-flex justify-content-center">
                  <div
                    style={{ width: 568, height: 56 }}
                    className="d-flex justify-content-between bg-palette-magenta-80"
                  >
                    <span className="color-white">80</span>
                  </div>
                  <div
                    style={{ width: 568, height: 56 }}
                    className="d-flex justify-content-between bg-palette-magenta-30"
                  >
                    <span>30</span>
                  </div>
                </div>
              </div>
              <div className="row mt-2">
                <div className="d-flex justify-content-center">
                  <div
                    style={{ width: 568, height: 56 }}
                    className="d-flex justify-content-between bg-palette-magenta-70"
                  >
                    <span className="color-white">70</span>
                  </div>
                  <div
                    style={{ width: 568, height: 56 }}
                    className="d-flex justify-content-between bg-palette-magenta-20"
                  >
                    <span>20</span>
                  </div>
                </div>
              </div>
              <div className="row mt-2">
                <div className="d-flex justify-content-center">
                  <div
                    style={{ width: 568, height: 56 }}
                    className="d-flex justify-content-between bg-palette-magenta-60"
                  >
                    <span className="color-white">60</span>
                  </div>
                  <div
                    style={{ width: 568, height: 56 }}
                    className="d-flex justify-content-between bg-palette-magenta-10"
                  >
                    <span>10</span>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-md-12 mt-3">
              <div style={titleColor}>
                <span className="body-text--lg bold-text">Magenta Hover</span>
              </div>
              <div className="row">
                <div className="d-flex justify-content-center">
                  <div
                    style={{ width: 568, height: 56 }}
                    className="d-flex justify-content-between bg-palette-magentaHover-100"
                  >
                    <span className="color-white">100</span>
                  </div>
                  <div
                    style={{ width: 568, height: 56 }}
                    className="d-flex justify-content-between bg-palette-magentaHover-50"
                  >
                    <span>50</span>
                  </div>
                </div>
              </div>
              <div className="row mt-2">
                <div className="d-flex justify-content-center">
                  <div
                    style={{ width: 568, height: 56 }}
                    className="d-flex justify-content-between bg-palette-magentaHover-90"
                  >
                    <span className="color-white">90</span>
                  </div>
                  <div
                    style={{ width: 568, height: 56 }}
                    className="d-flex justify-content-between bg-palette-magentaHover-40"
                  >
                    <span>40</span>
                  </div>
                </div>
              </div>
              <div className="row mt-2">
                <div className="d-flex justify-content-center">
                  <div
                    style={{ width: 568, height: 56 }}
                    className="d-flex justify-content-between bg-palette-magentaHover-80"
                  >
                    <span className="color-white">80</span>
                  </div>
                  <div
                    style={{ width: 568, height: 56 }}
                    className="d-flex justify-content-between bg-palette-magentaHover-30"
                  >
                    <span>30</span>
                  </div>
                </div>
              </div>
              <div className="row mt-2">
                <div className="d-flex justify-content-center">
                  <div
                    style={{ width: 568, height: 56 }}
                    className="d-flex justify-content-between bg-palette-magentaHover-70"
                  >
                    <span className="color-white">70</span>
                  </div>
                  <div
                    style={{ width: 568, height: 56 }}
                    className="d-flex justify-content-between bg-palette-magentaHover-20"
                  >
                    <span>20</span>
                  </div>
                </div>
              </div>
              <div className="row mt-2">
                <div className="d-flex justify-content-center">
                  <div
                    style={{ width: 568, height: 56 }}
                    className="d-flex justify-content-between bg-palette-magentaHover-60"
                  >
                    <span className="color-white">60</span>
                  </div>
                  <div
                    style={{ width: 568, height: 56 }}
                    className="d-flex justify-content-between bg-palette-magentaHover-10"
                  >
                    <span>10</span>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-md-12 mt-3">
              <div style={titleColor}>
                <span className="body-text--lg bold-text">Blue</span>
              </div>
              <div className="row">
                <div className="d-flex justify-content-center">
                  <div
                    style={{ width: 568, height: 56 }}
                    className="d-flex justify-content-between bg-palette-blue-100"
                  >
                    <span className="color-white">100</span>
                  </div>
                  <div
                    style={{ width: 568, height: 56 }}
                    className="d-flex justify-content-between bg-palette-blue-50"
                  >
                    <span>50</span>
                  </div>
                </div>
              </div>
              <div className="row mt-2">
                <div className="d-flex justify-content-center">
                  <div
                    style={{ width: 568, height: 56 }}
                    className="d-flex justify-content-between bg-palette-blue-90"
                  >
                    <span className="color-white">90</span>
                  </div>
                  <div
                    style={{ width: 568, height: 56 }}
                    className="d-flex justify-content-between bg-palette-blue-40"
                  >
                    <span>40</span>
                  </div>
                </div>
              </div>
              <div className="row mt-2">
                <div className="d-flex justify-content-center">
                  <div
                    style={{ width: 568, height: 56 }}
                    className="d-flex justify-content-between bg-palette-blue-80"
                  >
                    <span className="color-white">80</span>
                  </div>
                  <div
                    style={{ width: 568, height: 56 }}
                    className="d-flex justify-content-between bg-palette-blue-30"
                  >
                    <span>30</span>
                  </div>
                </div>
              </div>
              <div className="row mt-2">
                <div className="d-flex justify-content-center">
                  <div
                    style={{ width: 568, height: 56 }}
                    className="d-flex justify-content-between bg-palette-blue-70"
                  >
                    <span className="color-white">70</span>
                  </div>
                  <div
                    style={{ width: 568, height: 56 }}
                    className="d-flex justify-content-between bg-palette-blue-20"
                  >
                    <span>20</span>
                  </div>
                </div>
              </div>
              <div className="row mt-2">
                <div className="d-flex justify-content-center">
                  <div
                    style={{ width: 568, height: 56 }}
                    className="d-flex justify-content-between bg-palette-blue-60"
                  >
                    <span className="color-white">60</span>
                  </div>
                  <div
                    style={{ width: 568, height: 56 }}
                    className="d-flex justify-content-between bg-palette-blue-10"
                  >
                    <span>10</span>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-md-12 mt-3">
              <div style={titleColor}>
                <span className="body-text--lg bold-text">Blue Hover</span>
              </div>
              <div className="row">
                <div className="d-flex justify-content-center">
                  <div
                    style={{ width: 568, height: 56 }}
                    className="d-flex justify-content-between bg-palette-blueHover-100"
                  >
                    <span className="color-white">100</span>
                  </div>
                  <div
                    style={{ width: 568, height: 56 }}
                    className="d-flex justify-content-between bg-palette-blueHover-50"
                  >
                    <span>50</span>
                  </div>
                </div>
              </div>
              <div className="row mt-2">
                <div className="d-flex justify-content-center">
                  <div
                    style={{ width: 568, height: 56 }}
                    className="d-flex justify-content-between bg-palette-blueHover-90"
                  >
                    <span className="color-white">90</span>
                  </div>
                  <div
                    style={{ width: 568, height: 56 }}
                    className="d-flex justify-content-between bg-palette-blueHover-40"
                  >
                    <span>40</span>
                  </div>
                </div>
              </div>
              <div className="row mt-2">
                <div className="d-flex justify-content-center">
                  <div
                    style={{ width: 568, height: 56 }}
                    className="d-flex justify-content-between bg-palette-blueHover-80"
                  >
                    <span className="color-white">80</span>
                  </div>
                  <div
                    style={{ width: 568, height: 56 }}
                    className="d-flex justify-content-between bg-palette-blueHover-30"
                  >
                    <span>30</span>
                  </div>
                </div>
              </div>
              <div className="row mt-2">
                <div className="d-flex justify-content-center">
                  <div
                    style={{ width: 568, height: 56 }}
                    className="d-flex justify-content-between bg-palette-blueHover-70"
                  >
                    <span className="color-white">70</span>
                  </div>
                  <div
                    style={{ width: 568, height: 56 }}
                    className="d-flex justify-content-between bg-palette-blueHover-20"
                  >
                    <span>20</span>
                  </div>
                </div>
              </div>
              <div className="row mt-2">
                <div className="d-flex justify-content-center">
                  <div
                    style={{ width: 568, height: 56 }}
                    className="d-flex justify-content-between bg-palette-blueHover-60"
                  >
                    <span className="color-white">60</span>
                  </div>
                  <div
                    style={{ width: 568, height: 56 }}
                    className="d-flex justify-content-between bg-palette-blueHover-10"
                  >
                    <span>10</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Container>
      </div>
    </React.Fragment>
  );
}

export default Color;
